'use strict';

exports.__esModule = true;
exports.current = current;
exports.getSections = getSections;
exports.getSection = getSection;
exports.getProducts = getProducts;
exports.enableSection = enableSection;
exports.disableSection = disableSection;

var _apiClient = require('../network/api-client');

/**
 * Wrapper for `/partner/menus` API endpoint
 */

var API = {
  PARTNER_MENUS: '/partner_menus/menus'
};

var menus = {
  current: current,
  getSection: getSection,
  getSections: getSections,
  getProducts: getProducts,
  enableProduct: enableProduct,
  disableProduct: disableProduct,
  enableSection: enableSection,
  disableSection: disableSection
};

exports.default = menus;

/**
 * Get all current menu
 * @returns {promise} containing the entity object of current menu
 */

function current() {
  return (0, _apiClient.get)({
    route: API.PARTNER_MENUS + '/current'
  });
}

/**
 * Get menu sections
 * @param menuId : number
 * @returns {menu} containing the requested section of menu
 */
function getSections(_ref) {
  var menuId = _ref.menuId;

  return (0, _apiClient.get)({ route: API.PARTNER_MENUS + '/' + menuId + '/sections' });
}

/**
 * Get a section
 * @param menuId : number
 * @param sectionId : number
 * @returns {menu} containing the requested section details
 */
function getSection(_ref2) {
  var menuId = _ref2.menuId,
      sectionId = _ref2.sectionId;

  return (0, _apiClient.get)({ route: API.PARTNER_MENUS + '/' + menuId + '/sections/' + sectionId });
}

/**
 * Get products
 * @param menuId : number
 * @param sectionId : number
 * @param resultsPerPage : number
 * @param page : number
 * @returns {menu} containing products belonging to the requested section
 */
function getProducts(_ref3) {
  var menuId = _ref3.menuId,
      sectionId = _ref3.sectionId,
      _ref3$page = _ref3.page,
      page = _ref3$page === undefined ? 1 : _ref3$page,
      _ref3$resultsPerPage = _ref3.resultsPerPage,
      resultsPerPage = _ref3$resultsPerPage === undefined ? 15 : _ref3$resultsPerPage;

  return (0, _apiClient.get)({
    route: API.PARTNER_MENUS + '/' + menuId + '/sections/' + sectionId + '/products?page=' + page + '&per_page=' + resultsPerPage
  });
}

/**
 * PUT disable product
 * @param menuId : number
 * @param productId : number
 */
function enableProduct(menuId, productId) {
  return (0, _apiClient.put)({ route: API.PARTNER_MENUS + '/' + menuId + '/products/' + productId + '/enable' });
}

/**
 * PUT disable product
 * @param menuId : number
 * @param productId : number
 */
function disableProduct(menuId, productId) {
  return (0, _apiClient.put)({ route: API.PARTNER_MENUS + '/' + menuId + '/products/' + productId + '/disable' });
}

/**
 * PUT enable section
 * @param menuId : number
 * @param sectionId : number
 */
function enableSection(_ref4) {
  var menuId = _ref4.menuId,
      sectionId = _ref4.sectionId;

  return (0, _apiClient.put)({ route: API.PARTNER_MENUS + '/' + menuId + '/sections/' + sectionId + '/enable' });
}

/**
 * PUT disable section
 * @param menuId : number
 * @param sectionId : number
 **/
function disableSection(_ref5) {
  var menuId = _ref5.menuId,
      sectionId = _ref5.sectionId;

  return (0, _apiClient.put)({ route: API.PARTNER_MENUS + '/' + menuId + '/sections/' + sectionId + '/disable' });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/menus.js
// module id = 1066
// module chunks = 0